import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="border-y border-dark-border bg-black px-4 py-20" data-id="element-91">
      <motion.div initial={{
      opacity: 0,
      scale: 0.96
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="relative mx-auto max-w-4xl overflow-hidden rounded-3xl border border-gold/30 bg-dark-card p-8 text-center sm:p-12" data-id="element-92">
        <div className="absolute left-0 top-0 h-1 w-full bg-gold-gradient" data-id="element-93" />
        <ShieldCheck className="mx-auto mb-6 rounded-full bg-gold/10 p-5 text-gold" size={90} data-id="element-94" />
        <h2 className="font-serif text-3xl font-bold" data-id="element-95">
          Garantía total de 7 días
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-5 leading-relaxed text-gray-300" data-id="element-96">
          <p data-id="element-97">
            Abre los 8 tomos. Revisa los 4 bonos. Úsalos en tu clase más difícil
            esta semana.
          </p>
          <p className="font-medium text-white" data-id="element-98">
            Si sientes que el material no te ahorró horas de trabajo:
          </p>
          <p className="text-xl font-bold text-gold-light" data-id="element-99">
            Te devolvemos el 100% de tu dinero. Sin preguntas. Sin formularios.
            Sin complicaciones.
          </p>
          <p className="text-sm text-gray-400" data-id="element-100">
            Si el material no te da el valor que prometemos, no queremos
            quedarnos con tu dinero.
          </p>
        </div>
      </motion.div>
    </section>;
}